var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.headerClassName, 'header-wrap']},[_c('CampaignTopBanner',{attrs:{"visible":_vm.showCampaignBanner}}),_c('header',{attrs:{"id":"header"}},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"logo",on:{"click":_vm.backFrontIndex}}),_c('v-nav')],1),_c('div',{staticClass:"right"},[_c('info')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }